module.exports = __webpack_public_path__ + "static/img/8.0bed401.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/8.png
// module id = 9rbR
// module chunks = 0